import React, { useState, useEffect } from 'react'
import { Input } from 'semantic-ui-react';
import PropTypes from "prop-types";

const TextInput = ({ value: propValue, onBlur, onChange, ...rest }) => {
    const [value, setValue] = useState(propValue || '');
    useEffect(() => {
        setValue(propValue);
    }, [propValue]);

    const handleBlur = () => {
        onBlur?.(value);
    };

    const handleChange = (e, { value: newValue }) => {
        setValue(newValue);
        onChange?.(newValue);
    };

    return (
        <Input
            value={value}
            onBlur={handleBlur}
            onChange={handleChange}
            {...rest}
        />
    );
};

TextInput.propTypes = {
    value: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
};


export default TextInput;
